module.exports = __webpack_public_path__ + "img/d- (11).6d2867f7.png";